import update from 'immutability-helper';
import initialState from './shared';

export default update(initialState, {
  $merge: {
    queryParams: {
      action: undefined,
      field: 'date',
      init: 0,
      dateEnd: undefined,
      dateStart: undefined,
      deviceType: undefined,
      etir: undefined,
      order: 'desc',
      origin: undefined,
      result: 10,
      username: undefined
    },
    table: {
      filtered: [],
      sorted: [{
        desc: true,
        id: 'date'
      }]
    }
  }
});



// WEBPACK FOOTER //
// ./src/containers/Root/reducer/tables/initialState/dashboardOperations.js